module.exports = __webpack_public_path__ + "static/media/überweisung.f4f6645b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/static/documents/überweisung.pdf
// module id = 293
// module chunks = 0